<template>
  <div>
    <!--loader-->
    <div class="vld-parent">
      <loading
        loader="bars"
        :active.sync="isLoading"
        :can-cancel="true"
        :is-full-page="isFullPage"
      >
      </loading>
    </div>
    <div class="page-header clear-filter"></div>
    <!--loader-->

    <div
      class="section fixedTopSpacingOrder fixedContentMobileview"
      id="hideTopSpacingDivOrder"
    >
      <div class="container">
        <div class="row">
          <div
            class="col-12 col-sm-12 col-md-6 desktop-view"
            style="display: flex;place-content: center;align-items: center;"
          >
            <!--img src="img/home-page.jpg" class="img-responsive"-->
            <b-carousel
              id="carousel-1"
              fade
              v-model="slide"
              :interval="3000"
              indicators
              background="#fff"
              @sliding-start="onSlideStart"
              @sliding-end="onSlideEnd"
            >
              <!-- Slides with image only -->
              <b-carousel-slide
                img-src="img/order-slider3.png"
              ></b-carousel-slide>
              <!-- <b-carousel-slide img-src="img/home-page-2.jpg"></b-carousel-slide> -->
            </b-carousel>
          </div>
          <div class="col-12 col-sm-12 col-md-6 divider-left">
            <!-- <div
              class="container-banner"
              fxlayout="row"
              fxlayoutalign="center center"
              style="flex-direction: row; box-sizing: border-box; display: flex; place-content: center; align-items: center;"
            >
              <img
                alt="promo banner"
                class="container-banner"
                src="img/order-top.jpg"
              />
            </div> -->

            <!-- prod-list-screen-start -->
            <div v-if="isProdListCardShow">
              <div v-if="isPrepaidOnly == 'no'" class="product">
                Choose Product Plan
              </div>
              <div v-else class="product">Products</div>
              <b-form-group v-if="isPrepaidOnly == 'no'">
                <b-form-radio-group
                  id="btn-radios-3"
                  @change="cartUpdate()"
                  v-model="subscription_type"
                  :options="[
                    { text: 'Prepaid', value: 'Prepaid' },
                    { text: 'Postpaid', value: 'Postpaid' },
                  ]"
                  size="sm"
                  name="radio-btn-outline-type"
                  required
                  buttons
                ></b-form-radio-group>
              </b-form-group>
              <!-- card-row-first-start -->
              <b-row>
                <!-- card-column-left-start -->
                <b-col>
                  <!--div class="product">Product</div-->
                  <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 fixedProductHeight">
                      <div
                        class="dv-products"
                        fxflex="50"
                        fxlayoutalign="center start"
                        fxlayoutalign.lt-md="center center"
                      >
                        <div
                          fxflex="100"
                          fxlayout="column"
                          fxlayoutalign="center center"
                          style="flex-direction: column;"
                        >
                          <div
                            v-if="products && products.length > 0"
                            id="dv-products"
                            class="dv-products pd-bot-10 pd-top-10"
                          >
                            <div
                              v-for="product in products"
                              :key="product['product_id']"
                              fxlayout="row"
                              fxlayoutalign="center center"
                              style="margin-bottom: 10px; flex-direction: row; box-sizing: border-box; display: flex; place-content: center; align-items: center;"
                              class=""
                            >
                              <div
                                fxflex="16"
                                style="flex: 1 1 100%; box-sizing: border-box; max-width: 25%; text-align:center;"
                              >
                              <!--sanya: center aligning the image-->
                                <img
                                  style="height:70px;width:auto;"
                                  v-bind:src="product['product_image_s3_url']"
                                />        <!--sanya: changed height and width from fixed values-->
                              </div>

                              <div
                                class="ml-10"
                                fxflex="50"
                                fxlayout="column"
                                style="flex-direction: column; box-sizing: border-box; display: flex; flex: 1 1 100%; max-width: 50%;"
                              >
                                <div class="product-name-txt">
                                  {{ product["product_name"] }}
                                </div>
                                <div class="product-name-txt">
                                  {{
                                    product["product_price_list"][0]["quantity"]
                                  }}
                                  {{ product["product_price_list"][0]["unit"] }}
                                </div>
                                <div>
                                  <div
                                    style="float: left;text-decoration: line-through;color: gray;"
                                  >
                                    <span
                                      class="discountedPrice"
                                      v-if="subscription_type == 'Prepaid'"
                                      ><b
                                        style="float: left;text-decoration:none;font-weight:100;margin-right:0.2rem;"
                                        >MRP: ₹</b
                                      >
                                      {{
                                        product["mrp_without_discount"]
                                      }}.00</span
                                    >
                                    <span class="discountedPrice" v-else
                                      ><b
                                        style="float: left;text-decoration: none; font-weight:100;margin-right:0.2rem;"
                                        >MRP: ₹ &nbsp;</b
                                      >{{
                                        product["mrp_without_discount"]
                                      }}.00</span
                                    >
                                  </div>
                                  <div style="float:left; margin-left:0.5rem;">
                                    <span
                                      class="discountedPrice"
                                      v-if="subscription_type == 'Prepaid'"
                                      >- ₹
                                      {{ product["prepaid_price"] }}.00</span
                                    >
                                    <span class="discountedPrice" v-else
                                      >- ₹ {{ product["postpaid_price"] }}.00
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div
                                fxflex="34"
                                fxlayoutalign="end"
                                style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex; flex: 1 1 100%; max-width: 34%;"
                              >
                                <div
                                  v-if="product['status'] == 2"
                                  class="error-address"
                                >
                                  out of stock
                                </div>
                                <div v-else>
                                  <div
                                    v-if="
                                      product['quantity'] == 0 ||
                                        product['quantity'] == null
                                    "
                                    class="quantity-toggle"
                                  >
                                    <div class="quantity-toggle ">
                                      <div
                                        @click.prevent="increment(product)"
                                        class="dv-quantity-add-box"
                                      >
                                        <span>ADD</span>
                                        <i
                                          class="now-ui-icons ui-1_simple-add12"
                                        ></i>
                                        <!--b-icon icon="plus"></b-icon-->
                                      </div>
                                    </div>
                                  </div>
                                  <div v-else class="quantity-toggle">
                                    <div
                                      @click.prevent="decrement(product)"
                                      class="dv-quantity-sub"
                                      fxlayoutalign="center center"
                                      style="place-content: center; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;"
                                    >
                                      <i
                                        class="now-ui-icons ui-1_simple-delete"
                                      ></i>
                                      <!--b-icon style="height: 20px;width: 20px;" icon="dash"></b-icon-->
                                    </div>
                                    <div
                                      class="dv-quantity"
                                      fxlayoutalign="center center"
                                      style="place-content: center; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;"
                                    >
                                      <input
                                        type="text"
                                        :value="product['quantity']"
                                        readonly
                                      />
                                    </div>
                                    <div
                                      @click.prevent="increment(product)"
                                      class="dv-quantity-add"
                                      fxlayoutalign="center center"
                                      style="place-content: center; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;"
                                    >
                                      <i
                                        class="now-ui-icons ui-1_simple-add"
                                      ></i>
                                      <!--b-icon style="height: 20px;width: 20px;" icon="plus"></b-icon-->
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="product" id="show-more-prod" v-on:click.prevent="showMoreProducts()"
                            fxlayoutalign="center center"
                            style="place-content: center; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;">
                            <span>View More Products</span></div> -->
                          <div class="product">Delivery Start Date</div>
                          <div
                            class="topMargin leftMargin"
                            style="text-align: center;"
                          >
                            <b-form-group>
                              <b-form-radio-group
                                id="btn-radios-2"
                                v-model="start_date"
                                :options="options"
                                size="sm"
                                name="radio-btn-outline"
                                required
                                buttons
                              ></b-form-radio-group>
                            </b-form-group>

                            <div class="dv-total">
                              <span>Order Total &nbsp;</span
                              ><span style="font-family: 'san-sarif'"
                                >₹ {{ total_price_after_discount }}&nbsp;</span
                              >
                            </div>

                            <div
                              class="bottomMargin"
                              style="clear: both;"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <!-- card-row-first-end -->
              <!-- card-row-second-start -->
              <b-row
                ><!--v-if="isMobileVerified"-->
                <b-col align-self="center">
                  <div
                    class="dv-btn dv-btn-addon"
                    fxlayoutalign="center center"
                  >
                    <button
                      mat-raised-button=""
                      v-on:click.prevent="showLoginOrAddressOrFinalScreen()"
                      class="mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn"
                      value=""
                      :disabled="
                        !(total_product_quantity > 0) ||
                          /*!isMobileVerified ||*/ !start_date
                      "
                    >
                      <span class="mat-button-wrapper">PROCEED</span>
                      <div
                        class="mat-button-ripple mat-ripple"
                        matripple=""
                      ></div>
                      <div class="mat-button-focus-overlay"></div>
                    </button>
                  </div>
                </b-col>
              </b-row>
              <!-- card-row-second-end -->
            </div>
            <!-- prod-list-screen-end -->

            <!-- login-and-otp-screen-start -->
            <div
              v-if="isMobCardShow"
              class="loginAndOtpAndAddressForm loginAndOtp"
            >
              <!-- login-screen-start -->
              <div v-if="isSignUp === false">
                <h3 class="login-section">LOGIN</h3>
                <form class="login-form">
                  <div class="form-group">
                    <float-label>
                      <span class="input-group-addon">+91</span>
                      <input
                        id="mobile"
                        v-model="mobile"
                        required
                        oninput="javascript: if (this.value.length > 10) this.value = this.value.slice(0,10); this.value=this.value.replace(/[^0-9]/g,'');"
                        placeholder="Mobile Number*"
                        v-bind:class="{
                          'profile_edit form-control': true,
                          'is-invalid': !validMobile(mobile) && mobileBlured,
                        }"
                        v-on:blur="mobileBlured = true"
                        type="tel"
                      />
                      <div class="invalid-feedback">
                        please enter 10 digit valid mobile number
                      </div>
                    </float-label>
                  </div>
                  <div class="OTPForm">
                    <div class="w3-center">
                      <div
                        class="dv-btn dv-btn-addon"
                        fxlayoutalign="center center"
                      >
                        <button
                          mat-raised-button=""
                          v-on:click.prevent="signup()"
                          class="mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn"
                        >
                          <span class="mat-button-wrapper"
                            ><b>SEND OTP</b></span
                          >
                          <div
                            class="mat-button-ripple mat-ripple"
                            matripple=""
                          ></div>
                          <div class="mat-button-focus-overlay"></div>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <!-- login-screen-end -->

              <!-- otp-screen-start -->
              <div v-if="isSignUp">
                <h3 class="login-section">OTP</h3>

                <form class="login-form">
                  <float-label>
                    <div class="form-group">
                      <input
                        id="u-otp"
                        v-model="otp"
                        required
                        placeholder="OTP*"
                        oninput="javascript: if (this.value.length > 4) this.value = this.value.slice(0,4); this.value=this.value.replace(/[^0-9]/g,'');"
                        v-bind:class="{
                          'profile_edit form-control': true,
                          'is-invalid': !validOTP(otp) && otpBlured,
                        }"
                        v-on:blur="otpBlured = true"
                        type="tel"
                      />
                      <div class="invalid-feedback">
                        please enter 4 digit valid OTP
                      </div>
                    </div>
                  </float-label>

                  <div class="OTPForm">
                    <div class="w3-center">
                      <div class="login-section">
                        <h6>
                          Don't Recieve?
                          <a
                            class="underlineText"
                            v-on:click.prevent="resendotp()"
                          >
                            Resend OTP</a
                          >
                        </h6>
                      </div>
                      <div
                        class="dv-btn dv-btn-addon"
                        fxlayoutalign="center center"
                      >
                        <button
                          mat-raised-button=""
                          v-on:click.prevent="verifyotp()"
                          class="mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn"
                        >
                          <span class="mat-button-wrapper"
                            ><b>ENTER OTP</b></span
                          >
                          <div
                            class="mat-button-ripple mat-ripple"
                            matripple=""
                          ></div>
                          <div class="mat-button-focus-overlay"></div>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <!-- otp-screen-end -->
            </div>
            <!-- login-and-otp-screen-end -->

            <!-- address-screen-start -->
            <div v-if="isAddressCard" class="addressDiv">
              <div class="loginAndOtpAndAddressForm addressSection">
                <form>
                  <div>
                    <h5 class="product">
                      Delivery Address
                      <a
                        @click.prevent="editLocation()"
                        class="underlineText edit_location"
                        >Edit Location</a
                      >
                    </h5>
                    <p id="searchAddress" class="address-form-searchAddress">
                      {{ searchAddress }}
                    </p>
                  </div>

                  <div class="form-group">
                    <float-label>
                      <input
                        id="profile_name"
                        v-model="userDetails.first_name"
                        required
                        placeholder="Name*"
                        v-bind:class="{
                          'profile_edit form-control': true,
                          'is-invalid':
                            !validName(userDetails.first_name) && nameBlured,
                        }"
                        v-on:blur="nameBlured = true"
                      />
                      <div class="invalid-feedback">name is required</div>
                    </float-label>
                  </div>

                  <div class="form-group">
                    <float-label>
                      <input
                        id="profile_email"
                        v-model="userDetails.email"
                        required
                        placeholder="Email"
                        v-bind:class="{
                          'profile_edit form-control': true,
                          'is-invalid':
                            !validEmail(userDetails.email) && emailBlured,
                        }"
                        v-on:blur="emailBlured = true"
                      />
                      <div class="invalid-feedback">
                        please enter a valid email
                      </div>
                    </float-label>
                  </div>

                  <div class="form-group">
                    <float-label>
                      <input
                        id="address1"
                        v-model="address1"
                        required
                        placeholder="H.No | Floor | Locality *"
                        v-bind:class="{
                          'profile_edit location_edit form-control': true,
                          'is-invalid':
                            !validAddress1(address1) && address1Blured,
                        }"
                        v-on:blur="address1Blured = true"
                      />
                      <div class="invalid-feedback">
                        H.No | Floor | Locality is required
                      </div>
                    </float-label>
                  </div>

                  <div>
                    <float-label>
                      <input
                        id="address2"
                        v-model="address2"
                        placeholder="Landmark"
                        class="profile_edit location_edit form-control"
                      />
                    </float-label>
                  </div>
                  <br />

                  <b-row>
                    <b-col align-self="center">
                      <div
                        class="dv-btn dv-btn-addon"
                        fxlayoutalign="center center"
                      >
                        <button
                          mat-raised-button=""
                          v-on:click.prevent="updateProfileAddress()"
                          class="mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn"
                        >
                          <span class="mat-button-wrapper"
                            ><b>Save & Continue</b></span
                          >
                          <div
                            class="mat-button-ripple mat-ripple"
                            matripple=""
                          ></div>
                          <div class="mat-button-focus-overlay"></div>
                        </button>
                      </div>
                    </b-col>
                  </b-row>
                </form>
              </div>
            </div>
            <!-- address-screen-end -->

            <!-- final-calculated-card-start -->
            <div v-if="isFinalCart">
              <div class="row finalcart">
                <div class="col-12 col-sm-3 col-md-12"></div>
                <div class="col-12 col-sm-6 col-md-12">
                  <div>
                    <div class="product">
                      Delivery Address
                      <a
                        @click.prevent="editLocation()"
                        style="margin-right:2px;"
                        class="underlineText cart-table edit_location"
                        >Edit</a
                      >
                    </div>
                    <p id="cart-address">{{ custAddress }}</p>
                  </div>
                  <div style="display: grid;">
                    <table
                      border="0"
                      cellpadding="0"
                      cellspacing="0"
                      class="cart-table"
                    >
                      <tbody>
                        <tr class="cart-table-header-row">
                          <th class="product">Order Summary</th>
                          <th></th>
                          <th></th>
                          <th style="padding: 1px;">
                            <a
                              @click.prevent="backToProdList()"
                              class="underlineText edit_location"
                              >Edit</a
                            >
                          </th>
                        </tr>
                        <tr class="active">
                          <!-- <th>#</th> -->
                          <th style="width: 70%;">Product Name</th>
                          <th style="width: 10%; text-align:center;">Mrp</th>
                          <th style="width: 10%; text-align:center;">Qty</th>
                          <th style="width: 10%; text-align:center;">Amt</th>
                        </tr>
                        <tr
                          class="cart-table-content-row"
                          v-for="product in updatedCart"
                          v-bind:key="product.id"
                        >
                          <td style="width: 70%;">
                            {{ product.product_name }} ({{
                              product.product_quantity
                            }}
                            {{ product.product_unit }})
                          </td>
                          <div
                            v-if="
                              product.discounted_mrp < product.product_price
                            "
                          >
                            <td
                              style="width: 10%; text-align:center;font-family: 'san-sarif'"
                            >
                              <del>₹{{ product.product_price }}.00</del
                              >&nbsp;&nbsp;&nbsp;₹{{
                                product.discounted_mrp
                              }}.00
                            </td>
                          </div>
                          <div v-else>
                            <td
                              style="width: 10%; text-align:center; font-family: 'san-sarif'"
                            >
                              ₹{{ product.product_price }}.00
                            </td>
                          </div>
                          <td style="width: 10%; text-align:center;">
                            {{ product.quantity }}
                          </td>
                          <div
                            v-if="
                              product.discounted_mrp < product.product_price
                            "
                          >
                            <td
                              style="width: 10%; text-align:center; font-family: 'san-sarif'"
                            >
                              ₹{{
                                product.discounted_mrp * product.quantity
                              }}.00
                            </td>
                          </div>
                          <div v-else>
                            <td
                              style="width: 10%; text-align:center;font-family: 'san-sarif'"
                            >
                              ₹{{ product.product_price * product.quantity }}.00
                            </td>
                          </div>
                        </tr>
                        <!-- <tr><th></th><th></th><th></th></tr> -->
                        <tr class="cart-table-footer-row">
                          <td style="width: 70%;"><b>Order Total</b></td>
                          <td style="width: 10%; text-align:center;"></td>
                          <td style="width: 10%; text-align:center;"></td>
                          <td
                            style="width: 10%; text-align:center;font-family: 'san-sarif'"
                          >
                            <b>₹{{ updatedCartTotal.toFixed(2) }}</b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="row">
                    <div
                      v-if="noError === false"
                      class="col-12 col-sm-12 col-md-12"
                    >
                      <div class="wallet-msg">
                        <p>{{ errorMsg }}</p>
                      </div>
                    </div>
                    <div
                      v-if="isCouponApplied === true && couponAppliedMsg != ''"
                      class="col-12 col-sm-12 col-md-12"
                    >
                      <div class="coupon-applied-msg">
                        <p>{{ couponAppliedMsg }}</p>
                      </div>
                    </div>
                    <div class="col-5 col-sm-6 col-md-6">
                      <div class="product payment-mode">Payment Mode</div>
                    </div>
                    <div class="col-5 col-sm-6 col-md-6 mod-bal-float-right">
                      <div class="product sub-type" id="subscription-type">
                        {{ this.subscription_type }}
                      </div>
                    </div>
                  </div>
                  <div class="row " id="wallet-balance">
                    <div
                      class="col-5 col-sm-6 col-md-6"
                      v-if="subscription_type == 'Prepaid'"
                    >
                      <div class="product">Wallet Balance</div>
                    </div>
                    <div
                      class="col-5 col-sm-6 col-md-6 mod-bal-float-right"
                      v-if="subscription_type == 'Prepaid'"
                    >
                      <div
                        class="product discountedPrice"
                        id="subscription-type"
                      >
                        ₹ {{ walletBal }}.00
                      </div>
                    </div>
                  </div>
                  <div class="row" id="payment-method">
                    <div
                      class="col-12 col-sm-12 col-md-12"
                      v-if="subscription_type == 'Prepaid' && rechargeAmt > 0"
                    >
                      <div class="wallet-msg">
                        <p>{{ this.msg }}</p>
                      </div>
                      <div class="paymentType" style="text-align: left;">
                        <h4 style="font-weight:bold;letter-spacing: 0;">
                          Debit From
                        </h4>
                        <p v-if="apiDataObj.cc !== '0'">
                          <input
                            type="radio"
                            id="cc"
                            value="cc"
                            v-model="payment_type"
                            name="walletType"
                          />
                          <label for="cc"
                            >Credit, Debit Card / Net Banking </label
                          ><img src="img/wallet-icons/creditcard.png" />
                        </p>
                        <p v-if="apiDataObj.upi !== '0'">
                          <input
                            type="radio"
                            id="upi"
                            value="upi"
                            v-model="payment_type"
                            name="walletType"
                          />
                          <label for="upi">UPI </label
                          ><img src="img/wallet-icons/upi.png" />
                        </p>
                        <p v-if="apiDataObj.paytm !== '0'">
                          <input
                            type="radio"
                            id="paytm"
                            value="paytm"
                            v-model="payment_type"
                            name="walletType"
                          />
                          <label for="paytm">Paytm Wallet </label
                          ><img src="../../public/img/wallet-icons/paytm.png" />
                        </p>
                        <p v-if="apiDataObj.mobikwik !== '0'">
                          <input
                            type="radio"
                            id="mobikwik"
                            value="mobikwik"
                            v-model="payment_type"
                            name="walletType"
                          />
                          <label for="mobikwik">Mobikwik Wallet </label
                          ><img
                            src="../../public/img/wallet-icons/mobikwik.png"
                          />
                        </p>
                        <p v-if="apiDataObj.ola !== '0'">
                          <input
                            type="radio"
                            id="ola"
                            value="ola"
                            v-model="payment_type"
                            name="walletType"
                          />
                          <label for="ola">OLA Money Wallet </label
                          ><img
                            src="../../public/img/wallet-icons/olamoney.png"
                          />
                        </p>
                        <p v-if="apiDataObj.jio !== '0'">
                          <input
                            type="radio"
                            id="jio"
                            value="jio"
                            v-model="payment_type"
                            name="walletType"
                          />
                          <label for="jio">JIO Money Wallet</label
                          ><img
                            src="../../public/img/wallet-icons/jiomoney.png"
                          />
                        </p>
                        <p v-if="apiDataObj.freecharge !== '0'">
                          <input
                            type="radio"
                            id="freecharge"
                            value="freecharge"
                            v-model="payment_type"
                            name="walletType"
                          />
                          <label for="freecharge">FreeCharge Wallet</label>
                          <img
                            src="../../public/img/wallet-icons/freecharge.png"
                          />
                        </p>
                      </div>
                    </div>
                  </div>

                  <b-row
                    v-if="subscription_type == 'Prepaid' && rechargeAmt > 0"
                  >
                    <b-col align-self="center">
                      <div
                        class="dv-btn dv-btn-addon"
                        id="add-and-continue"
                        fxlayoutalign="center center"
                      >
                        <button
                          mat-raised-button=""
                          v-on:click.prevent="generateChecksum()"
                          class="mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn"
                        >
                          <span class="mat-button-wrapper discountedPrice"
                            >Add ₹ {{ this.rechargeAmt }} & Continue</span
                          >
                          <div
                            class="mat-button-ripple mat-ripple"
                            matripple=""
                          ></div>
                          <div class="mat-button-focus-overlay"></div>
                        </button>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row v-else>
                    <b-col align-self="center">
                      <div
                        class="dv-btn dv-btn-addon"
                        id="place-order"
                        fxlayoutalign="center center"
                      >
                        <button
                          mat-raised-button=""
                          v-on:click.prevent="submitCart()"
                          class="mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn"
                        >
                          <span class="mat-button-wrapper">Place Order</span>
                          <div
                            class="mat-button-ripple mat-ripple"
                            matripple=""
                          ></div>
                          <div class="mat-button-focus-overlay"></div>
                        </button>
                      </div>
                    </b-col>
                  </b-row>
                </div>
                <div class="col-12 col-sm-3 col-md-12"></div>
              </div>
            </div>
            <!-- final-calculated-card-end -->

            <!-- payment-card-start -->
            <div v-if="isPaymentCard">
              <!-- <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading> -->
              <div id="bafore_checksum" style="display:none;">
                <div v-if="userData">
                  <div id="url_valid">
                    <div style="text-align:center;">
                      <!-- <div><h4>Welcome {{custName}}<br>({{mobile}})</h4></div> -->
                      <p class="product wallet-header">Wallet</p>
                      <div class="wallet product">
                        <div id="not_pending">
                          <h4 class="available-balance-header">
                            Available Balance
                          </h4>
                          <div class="pending_wallet">
                            <!--sanya: newer version of fa icon-->
                            <i class="fas fa-rupee-sign" style="color: #fff;"></i
                            ><b style="color: #fff;"
                              >&nbsp;&nbsp;&nbsp;{{
                                apiDataObj.wallet_amount
                              }}</b
                            >
                          </div>
                        </div>
                      </div>
                      <br />
                      <p class="product select-amount-para">Select An Amount</p>
                      <div>
                        <div v-if="isQuickPaymentButtonDisplay === 1">
                          <input
                            class="quickPaymentButton"
                            v-model="btnOneValue"
                            type="button"
                            v-on:click.prevent="btnOneClick"
                          />
                          <input
                            id="quickPaymentButtonTwo"
                            class="quickPaymentButton"
                            v-model="btnTwoValue"
                            type="button"
                            v-on:click.prevent="btnTwoClick"
                          />
                          <input
                            id="quickPaymentButtonThree"
                            class="quickPaymentButton"
                            v-model="btnThreeValue"
                            type="button"
                            v-on:click.prevent="btnThreeClick"
                          />
                          <input
                            id="quickPaymentButtonFour"
                            class="quickPaymentButton"
                            v-model="btnFourValue"
                            type="button"
                            v-on:click.prevent="btnFourClick"
                          />
                        </div>
                        <form>
                          <p style="text-align: left;" class="product">
                            Enter Custom Amount
                          </p>
                          <div class="form-group">
                            <b-form-group
                              id="fieldset-1"
                              class="custom-amount-input"
                              label
                              for="Enter Custom Amount"
                              ><b-form-input
                                id="txn_amt"
                                class="amount_text"
                                name="TXN_AMOUNT"
                                type="number"
                                v-model="apiDataObj.default_amount"
                                :min="apiDataObj.default_amount"
                                oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                                placeholder="Enter Amount"
                              ></b-form-input>
                            </b-form-group>
                          </div>

                          <b-button
                            style="margin-top: -23px"
                            size="lg"
                            v-on:click.prevent="generateChecksum"
                            variant="primary"
                            class="btn-block dv-primary-btn"
                          >
                            Process To Pay
                            <b-icon
                              icon="credit-card"
                              aria-hidden="true"
                            ></b-icon>
                          </b-button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="after_checksum" style="display:none !important;">
                  <div class="after_checksum">
                    <br />
                    Dear {{ userDetails.first_name }}
                    <br />
                    {{ userDetails.address }}
                    <br /><br />
                    <!--sanya: newer version of fa icon-->
                    Amount<i class="fas fa-rupee-sign"></i
                    ><b>{{ genChecksum.TXN_AMOUNT }}</b
                    ><br /><br />
                    <div>
                      <form
                        method="post"
                        name="paytmFormSubmit"
                        id="paytmFormSubmit"
                        action="https://securegw.paytm.in/theia/processTransaction"
                      >
                        <!-- <form method="post" name="paytmFormSubmit" id="paytmFormSubmit" action="https://pguat.paytm.com/oltp-web/processTransaction"--><!-- staging -->
                        <input
                          type="hidden"
                          name="MID"
                          v-model="genChecksum.MID"
                        />
                        <input
                          type="hidden"
                          name="ORDER_ID"
                          v-model="genChecksum.ORDER_ID"
                        />
                        <input
                          type="hidden"
                          name="CUST_ID"
                          v-model="genChecksum.CUST_ID"
                        />
                        <input
                          type="hidden"
                          name="INDUSTRY_TYPE_ID"
                          v-model="genChecksum.INDUSTRY_TYPE_ID"
                        />
                        <input
                          type="hidden"
                          name="CHANNEL_ID"
                          v-model="genChecksum.CHANNEL_ID"
                        />
                        <input
                          type="hidden"
                          name="WEBSITE"
                          v-model="genChecksum.WEBSITE"
                        />
                        <input
                          type="hidden"
                          name="CALLBACK_URL"
                          v-model="genChecksum.CALLBACK_URL"
                        />
                        <input
                          type="hidden"
                          name="CHECKSUMHASH"
                          v-model="genChecksum.checksum"
                        />
                        <input
                          type="hidden"
                          name="TXN_AMOUNT"
                          v-model="genChecksum.TXN_AMOUNT"
                        />
                        <input
                          type="hidden"
                          name="MERC_UNQ_REF"
                          v-model="genChecksum.MERC_UNQ_REF"
                        />
                        <input
                          id="pay"
                          class="button5 btn btn-block dv-primary-btn"
                          value="Continue"
                          type="submit"
                          v-on:click.prevent="isLoading = true"
                        />
                      </form>
                    </div>
                  </div>
                </div>
                <div v-if="app_payment_gate" style="display:none !important;">
                  <div>
                    <br />
                    Dear {{ userDetails.first_name }}
                    <br />
                    {{ userDetails.address }}
                    <br />
                    <br />
                    <!--sanya: newer version of fa icon-->
                    Amount<span
                      >&nbsp;<i class="fas fa-rupee-sign"></i
                      ><b>&nbsp;{{ appPaymentGateway.TXN_AMOUNT }}</b></span
                    ><br /><br />
                    <div>
                      <!-- <form method="post" v-on:{{appPaymentGateway.actionUrl}}> -->
                      <form
                        method="post"
                        :action="formRequest"
                        name="hdfcFormSubmit"
                        id="hdfcFormSubmit"
                      >
                        <!-- <form method="post" action="https://doodhvale.in/dv/doodhvale/api/modules/v3/controllers/ccavRequestHandler.php"> -->
                        <!-- <form method="post" action="https://pguat.paytm.com/oltp-web/processTransaction"> --><!-- staging -->
                        <input
                          type="hidden"
                          name="tid"
                          v-model="appPaymentGateway.TID"
                        />
                        <!-- for test key-->
                        <!--<input type="hidden" name="merchant_id" value="208602"/>-->
                        <!-- for prod key-->
                        <input
                          type="hidden"
                          name="merchant_id"
                          value="242357"
                        />
                        <input
                          type="hidden"
                          name="order_id"
                          v-model="appPaymentGateway.ORDER_ID"
                        />
                        <input
                          type="hidden"
                          name="amount"
                          v-model="appPaymentGateway.TXN_AMOUNT"
                        />
                        <input type="hidden" name="currency" value="INR" />
                        <input
                          type="hidden"
                          name="redirect_url"
                          v-model="appPaymentGateway.responseUrl"
                        />
                        <input
                          type="hidden"
                          name="cancel_url"
                          v-model="appPaymentGateway.responseUrl"
                        />
                        <input type="hidden" name="language" value="EN" />
                        <input
                          type="hidden"
                          name="delivery_name"
                          v-model="userDetails.fullName"
                        />
                        <input
                          type="hidden"
                          name="delivery_address"
                          v-model="userDetails.address"
                        />
                        <input
                          type="hidden"
                          name="delivery_city"
                          v-model="userDetails.city"
                        />
                        <input
                          type="hidden"
                          name="delivery_state"
                          v-model="userDetails.state"
                        />
                        <input
                          type="hidden"
                          name="delivery_zip"
                          v-model="pincode"
                        />
                        <input
                          type="hidden"
                          name="delivery_country"
                          value="India"
                        />
                        <input
                          type="hidden"
                          name="delivery_tel"
                          v-model="mobile"
                        />
                        <input
                          type="hidden"
                          name="merchant_param1"
                          v-model="apiDataObj.userId"
                        />
                        <input
                          type="hidden"
                          name="merchant_param2"
                          v-model="appPaymentGateway.CALLBACK_URL"
                        />
                        <input
                          type="hidden"
                          name="merchant_param3"
                          v-model="appPaymentGateway.APP_PAYMENT_GATEWAY"
                        />
                        <input
                          type="hidden"
                          name="merchant_param4"
                          v-model="appPaymentGateway.apiUrl"
                        />
                        <input
                          id="hdfc-pay"
                          class="button5 btn btn-block dv-primary-btn"
                          value="Continue"
                          type="submit"
                          v-on:click.prevent="isLoading = true"
                        />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- payment-card-end -->

            <!-- informational-card-start -->
            <div class="information-card" v-if="isInformationalCard">
              <b-row>
                <b-col align-self="center">
                  <div
                    v-for="product in updatedProdList"
                    :key="product['product_id']"
                  >
                    <b-list-group class="product">
                      <b-list-group-item
                        class="d-flex justify-content-between align-items-center"
                      >
                        {{ product.product_name }} -> {{ product.msg }}
                        <b-icon
                          v-if="
                            product.msg ===
                              'You have subscribed successfully.' ||
                              product.msg === 'Success'
                          "
                          icon="check-box"
                          scale="1"
                          variant="Success"
                        ></b-icon>
                        <b-icon
                          v-if="
                            product.msg !=
                              'You have subscribed successfully.' &&
                              product.msg != 'Success'
                          "
                          icon="x-circle"
                          scale="1"
                          variant="danger"
                        ></b-icon>
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                  <button
                    mat-raised-button=""
                    v-on:click.prevent="goback()"
                    class="mat-raised-button  btn btn-info btn-lg btn-block dv-primary-btn"
                  >
                    <span class="mat-button-wrapper">OK</span>
                    <div
                      class="mat-button-ripple mat-ripple"
                      matripple=""
                    ></div>
                    <div class="mat-button-focus-overlay"></div>
                  </button>
                </b-col>
              </b-row>
            </div>
            <!-- informational-card-end -->
          </div>
          <!-- product description start -->
          <div class="col-12 col-sm-12">
            <!-- product name and description section start -->
            <div class="container short-products">
              <div
                v-for="product in shortProducts"
                :key="product['product_id']"
                class="row"
              >
                <div class="col-lg-3 col-md-5 col-sm-5 align-self-center">
                  <div
                    class="dv-products"
                    fxflex="50"
                    fxlayoutalign="center start"
                    fxlayoutalign.lt-md="center center"
                  >
                    <div
                      @click.prevent="productRedirection(product)"
                      fxflex="100"
                      fxlayout="column"
                      fxlayoutalign="center center"
                      style="flex-direction: column;cursor: pointer;"
                      class="text-center"
                    >
                      <strong>{{ product["product_name"] }} </strong>
                    </div>
                    <!--sanya: added images alongside product name-->
                    <div style = "text-align: center;">
                      <img style="position: relative;top:5px;height:90px;width:auto;" v-bind:src="product['product_image_s3_url']"/> 
                    </div>
                  </div>
                </div>
                <div class="col-lg-9 col-md-7 col-sm-7 short-desc">
                  <!--h3 class="product__title our-products" @click="()=>$router.push('product/'+ product['url_name'])">{{product['product_name']}}</h3-->
                  <p
                    style="cursor: pointer;"
                    @click.prevent="productRedirection(product)"
                    class="product__shortdesc"
                  >
                    {{ product["product_description"] }}
                  </p>
                  <p class="product__description" style="text-align: justify;">
                    {{ product["prod_description"] }}
                  </p>

                  <p>
                    <!-- Via multiple directive modifiers -->
                    <a
                      class="nutritional-detail"
                      v-b-toggle="'collapse-' + product['product_id']"
                      variant="primary"
                    >
                      {{ "Nutritional Information" }}
                      <b-icon icon="caret-down-fill"></b-icon>
                    </a>

                    <!-- Elements to collapse -->
                    <b-collapse
                      :id="'collapse-' + product['product_id']"
                      class="mt-2"
                    >
                      <b-card>
                        <table class="tg">
                          <thead>
                            <tr>
                              <th class="tg-62l6" colspan="2">
                                Nutritional Information<br />Amount per 100g
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(value, name) in product['nutriTable']"
                              :key="name"
                            >
                              <td class="tg-0pky">{{ name }}</td>
                              <td class="tg-0pky">{{ value }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </b-card>
                    </b-collapse>
                  </p>
                </div>
              </div>
            </div>
            <!-- product name and description section end -->
          </div>
          <!-- product description start -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Card, Tabs, TabPane, Button, FormGroupInput } from "@/components";
import axios from "axios";
import { gmapApi } from "vue2-google-maps";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "profile",
  bodyClass: "profile-page",
  components: {
    Tabs,
    TabPane,
    Card,
    [FormGroupInput.name]: FormGroupInput,
    Loading,
  },
  computed: {
    google: gmapApi,
    mobstate() {
      if (
        isNaN(this.mobile) ||
        this.mobile.length !== 10 ||
        this.mobile === ""
      ) {
        return false;
      } else {
        return true;
      }

      //return this.mobile.length == 10 ? true : false
    },
    validFeedback() {
      return this.mobstate === true ? "" : "";
    },
    otpstate() {
      if (isNaN(this.otp) || this.otp.length !== 4 || this.otp === "") {
        return false;
      } else {
        return true;
      }
    },
  },
  data() {
    return {
      apiUrl: "https://doodhvale.in/dv/",
      //apiUrl: 'http://localhost:8888/doodhvale-admin/',
      formRequest:
        "https://doodhvale.in/dv/doodhvale/api/modules/v3/controllers/ccavRequestHandler.php",
      // vueUrl: 'http://localhost:8080/order',
      vueUrl: "https://www.doodhvale.com/order",
      //vueUrl: 'https://t.doodhvale.in/order',
      //vueUrl: 'https://www.doodhvale.com/dev-app/order',
      center: { lat: 28.664081, lng: 77.389001 },
      markers: [
        {
          position: { lat: 28.664081, lng: 77.389001 },
        },
      ],
      slide: 0,
      sliding: null,
      isPaymentCard: false,
      reqWallAmt: 0,
      rechargeAmt: 0,
      otp: "",
      mobile: "",
      isPrepaidOnly: "no",
      pincode: "000000",
      city: "North Delhi",
      country: "",
      state: "",
      locality: "",
      formattedAddress: "",
      profileSet: [],
      userDetails: [],
      cityList: [],
      gender: "M",
      profile: false,
      isInformationalCard: false,
      updatedProdList: [],
      address1: "",
      address2: "",
      total_price_before_discount: 0,
      total_price_after_discount: 0,
      tomorrow: new Date(),
      tomorrowplus1: new Date(),
      tomorrowplus2: new Date(),
      products: [],
      quantity: 0,
      selected: "first",
      start_date: false,
      options: [],
      days: 0,
      isMobileVerified: false,
      isAddressCard: false,
      isSignUp: false,
      isProdListCardShow: true,
      isMobCardShow: false,
      cart: [],
      updatedCart: [],
      updatedCartTotal: 0,
      list: [],
      isFinalCart: false,
      isShowErrorMsg: false,
      isCouponApplied: false,
      couponAppliedMsg: "",
      errorMsg: "",
      noError: true,
      userId: 451,
      total_product_quantity: 0,
      ringOnNotSelected: false,
      ringOnSelected: true,
      ringOffNotSelected: true,
      ringOffSelected: false,
      subscription_type: "Prepaid",
      is_profile: 0,
      // pp.vue data() start
      payment_url: "",
      urlInterface: [],
      apiDataObj: [],
      genChecksum: [],
      appPaymentGateway: [],
      after_checksum: false,
      userData: true,
      app_payment_gate: false,
      payment_type: "cc",
      errors: "",
      isActive: false,
      isLoading: true,
      isLoaded: false,
      isFullPage: true,
      btnOneValue: 100,
      btnTwoValue: 200,
      btnThreeValue: 500,
      btnFourValue: 1000,
      isQuickPaymentButtonDisplay: 1,
      fiveDeliveryAmount: 100,
      sevenDeliveryAmount: 200,
      fifteenDeliveryAmount: 400,
      thirtyDeliveryAmount: 800,
      fourtyFiveDeliveryAmount: 1200,
      sixtyDeliveryAmount: 1600,
      ninetyDeliveryAmount: 2400,
      custName: "",
      custAddress: "",
      fiveDeliveryAmountLabel: "5 Deliveries",
      sevenDeliveryAmountLabel: "7 Deliveries",
      fifteenDeliveryAmountLabel: "15 Deliveries",
      thirtyDeliveryAmountLabel: "30 Deliveries",
      fourtyFiveDeliveryAmountLabel: "45 Deliveries",
      sixtyDeliveryAmountLabel: "60 Deliveries",
      ninetyDeliveryAmountLabel: "90 Deliveries",
      emailBlured: false,
      nameBlured: false,
      mobileBlured: false,
      otpBlured: false,
      searchAddressBlured: false,
      address1Blured: false,
      searchAddress: "",
      msg: "",
      walletBal: 0,
      max_order_quantity: 6,
      shortProducts: [],
      showNutritional: false,
      nutriTable: {},
      paneer: {
        Energy: "289 kcal",
        "Energy from FAT": "225 g",
        Energy: "289 kcal",
        "Total FAT": "25 g",
        "Saturated FAT": "15 g",
        Cholesterol: "66 mg",
        Carbohydrates: "2 g",
        "Added Sugar": "0 g",
        Protein: "14 g",
        Calcium: "480 mg",
      },
      cowMilk: {
        Energy: "68 kcal",
        "Milk FAT": "3.5 g",
        Carbohydrates: "5 g",
        "Milk Protein": "3.3 g",
        Calcium: "110 mg",
      },
      lowFatCowMilk: {
        Energy: "52 kcal",
        "Milk FAT": "1.5 g",
        Carbohydrates: "5.4 g",
        "Milk Protein": "3.4 g",
        Calcium: "145 mg",
      },
      buffaloMilk: {
        Energy: "90 kcal",
        "Milk FAT": "6.5 g",
        Carbohydrates: "5.0 g",
        "Milk Protein": "3.3 g",
        Calcium: "135 mg",
      },
      dahi: {
        "Energy Value": "63 kcal",
        Protein: "3.5 g",
        "Carbohydrates ": "5.0 g",
        Sugar: "0.0 g",
        Calcium: "150 mg",
        FAT: "3.0 g",
        SNF: "8.5 g",
      },
      //pp.vue data() end
    };
  },
  metaInfo() {
    return {
      title: "Doodhvale - Farm fresh Milk, Delhi-NCR - All Products",
      meta: [
        {
          name: "description",
          content:
            "Doodhvale is an online app based dairy which delivers farm fresh & 100% pure cow and buffalo milk within few hours of milking. Order dairy, chemical free bread, bakery, fruits, vegetables and grocery. Dairy Near to me!",
        },
        {
          name: "keywords",
          content:
            "Doodhvale, Dairy Products, Cow milk, Buffalo milk, Toned, Paneer, Dahi, Desi Ghee, Chemical free bread, bakery, fruits, vegetables, grocery, dosa batter, Free Home Delivery",
        },
        // OpenGraph data (Most widely used)
        {
          property: "og:title",
          content:
            "Doodhvale - Farm fresh Milk, Delhi-NCR, Chandigarh, Mohali, Panchkula - All Products",
        },
        { property: "og:site_name", content: "Doodhvale" },
        { property: "og:type", content: "website" },
        {
          property: "og:description",
          content:
            "Doodhvale is an online app based dairy which delivers farm fresh & 100% pure cow and buffalo milk within few hours of milking. Order dairy, chemical free bread, bakery, fruits, vegetables and grocery. Dairy Near to me!",
        },
        { property: "og:url", content: "https://www.doodhvale.com/order" },
        // Twitter card
        { name: "twitter:card", content: "summary" },
        //{name: 'twitter:site', content: 'https://www.doodhvale.com/our-farms'},
        {
          name: "twitter:title",
          content:
            "Doodhvale - Farm fresh Milk, Delhi-NCR, Chandigarh, Mohali, Panchkula - All Products",
        },
        {
          name: "twitter:description",
          content:
            "Doodhvale is an online app based dairy which delivers farm fresh & 100% pure cow and buffalo milk within few hours of milking. Order dairy, chemical free bread, bakery, fruits, vegetables and grocery. Dairy Near to me!",
        },
        // Your twitter handle, if you have one.
        //{name: 'twitter:creator', content: '@alligatorio'}
        //{name: 'twitter:image:src', content: 'https://www.my-site.com/my-special-image.jpg'},
        //{name: 'robots', content: 'index,follow'}
      ],
      link: [{ rel: "canonical", href: "https://www.doodhvale.com/order" }],
    };
  },
  created() {
    var bottomMenu = document.getElementById("bottomMenu");
    if (bottomMenu) {
      bottomMenu.classList.add("hidebottomMenu");
      document.getElementById("sm_bottom_menu").style.top = "-80px";
      //document.getElementById('sm_bottom_menu').style.bottom = '0'
    }
    this.getProductList();
    //this.userLocation()
    this.getShortProductList();
  },

  mounted() {
    // debugger
    var condition = localStorage.getItem("isMobileVerified");
    if (condition) {
      this.isMobileVerified = true;
      var navbar = JSON.parse(localStorage.getItem("navbar"));
      var smAdd = document.getElementById("smallAddress");
      var text_to_change = smAdd.childNodes[0];
      text_to_change.nodeValue = navbar.smallAddress;

      var addressFormData = JSON.parse(localStorage.getItem("addressFormData"));

      this.userId = addressFormData.userId;
      this.userDetails.first_name = addressFormData.first_name;
      document.getElementById("logout-menu").style.display = "block";
      document.getElementById("f-logout").style.display = "block";
      var loginUser = "";
      if (addressFormData.first_name) {
        loginUser = addressFormData.first_name;
      } else {
        loginUser = addressFormData.mobile;
      }
      document.getElementById("login-user").innerHTML = "welcome, " + loginUser;
      this.userDetails.pincode = addressFormData.pincode;
      this.address1 = addressFormData.address1;
      this.address2 = addressFormData.address2;
      this.state = addressFormData.state;
      this.gps_address = addressFormData.gps_address;
      this.searchAddress = addressFormData.searchAddress;
      this.markers[0].position.lat = addressFormData.latitude;
      this.markers[0].position.lng = addressFormData.longitude;
      this.locality = addressFormData.locality;
      this.userDetails.email = addressFormData.email;
      this.mobile = addressFormData.mobile;

      this.custAddress = localStorage.getItem("custAddress");

      // this.cart = localStorage.getItem('cart')
    }
  },

  methods: {
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
    productRedirection(product) {
      switch (product["product_id"]) {
        case 1:
          window.open(
            "https://live.doodhvale.com/fresh-cow-milk-glass-bottle/"
          );
          break;
        case 344:
          window.open("https://live.doodhvale.com/farm-fresh-cow-milk/");
          break;
        case 151:
          window.open("https://live.doodhvale.com/low-fat-fresh-cow-milk/");
          break;
        case 345:
          window.open("https://live.doodhvale.com/fresh-buffalo-milk-a2/");
          break;
        default:
          this.$router.push("product/" + product["url_name"]);
      }
    },
    getShortProductList() {
      let params = new URLSearchParams();
      params.append("user_id", this.userId);
      params.append("cat_id", 2);
      axios
        .post(
          this.apiUrl +
            "doodhvale/api/web/v3/products/products-with-pre-post-price",
          params
        )
        .then((response) => {
          this.shortProducts = response.data.product_list;
          var myself = this;
          var result = this.shortProducts.map(function(el) {
            var o = Object.assign({}, el);
            if (o.product_id == 151) {
              o.nutriTable = myself.lowFatCowMilk;
            }
            if (o.product_id == 344 || o.product_id == 1) {
              o.nutriTable = myself.cowMilk;
            }
            if (o.product_id == 345) {
              o.nutriTable = myself.buffaloMilk;
            }
            if (o.product_id == 7) {
              o.nutriTable = myself.dahi;
            }
            if (o.product_id == 110) {
              o.nutriTable = myself.paneer;
            }
            return o;
          });
          this.shortProducts = result;
        })
        .catch((e) => {});
    },
    validate: function() {
      this.nameBlured = true;
      this.address1Blured = true;
      if (
        this.validAddress1(this.address1) &&
        this.validEmail(this.userDetails.email) &&
        this.validName(this.userDetails.first_name)
      ) {
        return true;
      } else {
        return false;
      }
    },

    validMobileForm: function() {
      this.mobileBlured = true;

      if (this.validMobile(this.mobile)) {
        return true;
      } else {
        return false;
      }
    },

    validOTPForm: function() {
      this.otpBlured = true;

      if (this.validOTP(this.otp)) {
        return true;
      } else {
        return false;
      }
    },

    validEmail: function(email) {
      if (typeof email == "undefined") {
        email = "";
      }
      if (email == "") {
        return true;
      }
      var re = /(.+)@(.+){2,}\.(.+){2,}/;
      return re.test(email.toLowerCase());
    },

    validMobile: function(mobile) {
      // debugger
      if (typeof mobile == "undefined") {
        mobile = "";
      }
      mobile = mobile.slice(0, 10);
      if (isNaN(mobile) || mobile.length !== 10 || mobile === "") {
        return false;
      }
      return true;
    },

    validOTP: function(otp) {
      // debugger
      if (typeof otp == "undefined") {
        otp = "";
      }
      otp = otp.slice(0, 4);
      if (isNaN(this.otp) || this.otp.length < 4 || this.otp === "") {
        return false;
      }
      return true;
    },

    validName: function(name) {
      if (typeof name == "undefined") {
        name = "";
      }
      if (name == "") {
        return false;
      } else {
        return true;
      }
    },

    validAddress1: function(address1) {
      if (typeof address1 == "undefined") {
        address1 = "";
      }
      if (address1 == "") {
        return false;
      } else {
        return true;
      }
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    showMoreProducts() {
      document.getElementById("dv-products").style.overflow = "auto";
      document.getElementById("show-more-prod").style.display = "none";
    },
    editLocation() {
      if (this.isFinalCart === true) {
        (this.couponAppliedMsg = ""),
          (this.errorMsg = ""),
          (this.isCouponApplied = false);
        this.noError = true;
        this.isFinalCart = false;
        this.isAddressCard = true;
        return;
      }
      this.$bvModal.show("bv-modal-address");
      setTimeout(function() {
        if (document.getElementById("userAddress")) {
          var see = document.getElementById("searchAddress").innerHTML;
          document.getElementById(
            "userAddress"
          ).value = document.getElementById("searchAddress").innerHTML;
        }
      }, 100);
      setTimeout(function() {
        document.getElementById("madal-error-address").style.display = "none";
      }, 4000);
    },

    cartUpdate() {
      this.getProductList();
      // localStorage.clear()
      this.cart = [];
      sessionStorage.clear();
      this.total_product_quantity = 0;
      this.total_price_after_discount = 0;
      this.total_price_before_discount = 0;
    },

    address(lats, lngs) {
      //debugger
      let latlng = { lat: lats, lng: lngs };
      const google = window.google;
      // alert(google)
      if (google !== undefined) {
        var geocoder = new google.maps.Geocoder();
        var myScope = this;
        geocoder.geocode({ location: latlng }, function(results, status) {
          if (status === "OK") {
            if (results[0]) {
              myScope.fillAddress(results);
            } else {
              window.alert("No location found");
            }
          } else {
            //window.alert('Geocoder failed due to: ' + status);
          }
        });
      } else {
        //debugger
        axios
          .get(
            "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
              lats +
              "," +
              lngs +
              "&key=AIzaSyArGgueGCb2p4sqjU4pScADLskS9OxZ8jQ"
          )
          .then((response) => {
            // Ideally you'd search for the index with type = sublocality in address_components
            this.fillAddress(response.data.results);
          });
      }
    },
    fillAddress(address) {
      if (document.getElementById("del_loc")) {
        document.getElementById("del_loc").value = address[0].formatted_address;
        //document.getElementById('searchAddress').value = address[0].formatted_address
      }
      // debugger
      var myAddress = document.getElementById("searchAddress");
      if (myAddress) {
        // this.searchAddress = address[0].formatted_address
        myAddress.innerHTML = address[0].formatted_address;
        document.getElementById("hfullAddress").value =
          address[0].formatted_address;
      }
      this.formattedAddress = address[0].formatted_address;
      let full_address = address[0].address_components;
      let sublocality_level_1 = "";
      let sublocality_level_2 = "";
      let sublocality_level_3 = "";
      for (var i = 0; i < full_address.length; i++) {
        if (full_address[i].types.includes("sublocality_level_1")) {
          sublocality_level_1 = full_address[i].long_name;
        }
        if (full_address[i].types.includes("sublocality_level_2")) {
          sublocality_level_2 = full_address[i].long_name;
        }
        if (full_address[i].types.includes("sublocality_level_3")) {
          sublocality_level_3 = full_address[i].long_name;
        }
        if (full_address[i].types.includes("locality")) {
          this.locality = full_address[i].long_name;
        }
        if (full_address[i].types.includes("administrative_area_level_2")) {
          this.city = full_address[i].long_name;
        }
        if (full_address[i].types.includes("administrative_area_level_1")) {
          this.state = full_address[i].long_name;
        }
        if (full_address[i].types.includes("country")) {
          this.country = full_address[i].long_name;
        }
        if (full_address[i].types.includes("postal_code")) {
          this.pincode = full_address[i].long_name;
        }
      }

      /* let length = full_address[0].address_components.length
      length = length - 1
      this.pincode = full_address[0].address_components[length].long_name
      length = length - 1
      this.country = full_address[0].address_components[length].long_name
      length = length - 1
      this.state = full_address[0].address_components[length].long_name
      length = length - 1
      this.locality = full_address[0].address_components[length].long_name
      length = length - 1
      this.city = full_address[0].address_components[length].long_name
      this.formattedAddress = full_address[0].formatted_address
      let sublocality_level_1 = full_address[0].address_components[4].long_name
      let sublocality_level_2 = full_address[0].address_components[3].long_name
      let sublocality_level_3 = full_address[0].address_components[2].long_name */
      let smallAddress = "";
      if (sublocality_level_3) {
        smallAddress = sublocality_level_3;
      } else if (sublocality_level_2) {
        smallAddress = sublocality_level_2;
      } else if (sublocality_level_1) {
        smallAddress = sublocality_level_1;
      } else if (this.locality) {
        smallAddress = this.locality;
      } else {
        smallAddress = "";
      }
      smallAddress = smallAddress + ", " + this.pincode;
      var smAdd = document.getElementById("smallAddress");
      var text_to_change = smAdd.childNodes[0];
      text_to_change.nodeValue = smallAddress;

      this.saveLocalStorageData();
    },

    saveLocalStorageData() {
      // debugger
      var addressFormData = {};
      var navbar = {};
      var smAdd = document.getElementById("smallAddress");
      var text_to_change = smAdd.childNodes[0];
      var custAddress;
      var cart;

      navbar.smallAddress = text_to_change.nodeValue;
      navbar.lat = this.markers[0].position.lat;
      navbar.lng = this.markers[0].position.lng;

      addressFormData.userId = this.userId;
      addressFormData.first_name = this.userDetails.first_name;
      addressFormData.pincode = this.pincode;
      addressFormData.address1 = this.address1;
      addressFormData.address2 = this.address2;
      addressFormData.searchAddress = document.getElementById(
        "searchAddress"
      ).innerHTML;
      addressFormData.searchAddress = this.formattedAddress;
      addressFormData.email = this.userDetails.email;
      addressFormData.state = this.state;
      addressFormData.gps_address = document.getElementById(
        "searchAddress"
      ).innerHTML;
      addressFormData.gps_address = this.formattedAddress;
      addressFormData.latitude = this.markers[0].position.lat;
      addressFormData.longitude = this.markers[0].position.lng;
      addressFormData.locality = this.locality;
      addressFormData.mobile = this.mobile;

      custAddress =
        this.address1 +
        ", " +
        document.getElementById("searchAddress").innerHTML;

      cart = this.cart;

      addressFormData = JSON.stringify(addressFormData);
      navbar = JSON.stringify(navbar);
      cart = JSON.stringify(cart);
      localStorage.setItem("isMobileVerified", true);
      localStorage.setItem("addressFormData", addressFormData);
      localStorage.setItem("navbar", navbar);
      localStorage.setItem("custAddress", custAddress);
    },
    increment(product) {
      if (product["quantity"] == null) {
        product["quantity"] = 0;
      }
      var product_price;
      this.max_order_quantity = product.prod_max_order_quantity;
      if (this.subscription_type == "Prepaid") {
        product_price = product["prepaid_price"];
      } else {
        product_price = product["postpaid_price"];
      }
      product["last_quantity"] = product["quantity"];
      if (
        0 <= product["quantity"] &&
        product["quantity"] < this.max_order_quantity
      ) {
        product["quantity"]++;
        this.total_product_quantity++;
        this.total_price_before_discount += product_price * this.days;
        this.total_price_after_discount = this.total_price_before_discount; //- (this.total_price_before_discount)).toFixed(2)
      }

      sessionStorage.setItem("products", JSON.stringify(this.products));
      sessionStorage.setItem(
        "total_product_quantity",
        this.total_product_quantity
      );
      sessionStorage.setItem(
        "total_price_before_discount",
        this.total_price_before_discount
      );
      sessionStorage.setItem(
        "total_price_after_discount",
        this.total_price_after_discount
      );
    },

    decrement(product) {
      if (product["quantity"] == null) {
        product["quantity"] = 0;
      }
      var product_price;
      this.max_order_quantity = product.prod_max_order_quantity;
      if (this.subscription_type == "Prepaid") {
        product_price = product["prepaid_price"];
      } else {
        product_price = product["postpaid_price"];
      }
      if (
        1 <= product["quantity"] &&
        product["quantity"] <= this.max_order_quantity
      ) {
        product["quantity"]--;
        this.total_product_quantity--;
        this.total_price_before_discount -= product_price * this.days;
        this.total_price_after_discount = this.total_price_before_discount; //- (this.total_price_before_discount)).toFixed(2)
      }

      sessionStorage.setItem("products", JSON.stringify(this.products));
      sessionStorage.setItem(
        "total_product_quantity",
        JSON.stringify(this.total_product_quantity)
      );
      sessionStorage.setItem(
        "total_price_before_discount",
        this.total_price_before_discount
      );
      sessionStorage.setItem(
        "total_price_after_discount",
        this.total_price_after_discount
      );
    },

    convertDate(dateString) {
      var mydate = new Date(dateString).toDateString().split(" ");
      return mydate[2] + " " + mydate[1] + " " + mydate[3];
    },

    showLoginOrAddressOrFinalScreen() {
      // debugger
      var headerLat = document.getElementById("headerLat").value;
      if (this.isMobileVerified === false) {
        // loginAndOtp Screen
        this.isMobCardShow = true;
        this.isProdListCardShow = false;
      } else if (localStorage.getItem("databaseSavedLat") != headerLat) {
        // address Screen
        this.populateAddressForm();
        this.isAddressCard = true;
        this.isProdListCardShow = false;
      } else {
        // orderSummary Screen
        this.finalCart();
        // if (this.subscription_type=='Prepaid'){
        this.verifySubscription();
        // }
        this.isFinalCart = true;
        this.isProdListCardShow = false;
      }
      this.scrollToTop();
    },

    populateAddressForm() {
      // debugger
      var self = this;
      let latitude = document.getElementById("headerLat").value;
      let longitude = document.getElementById("headerLng").value;
      let hfullAddress = document.getElementById("hfullAddress").value;
      self.center = {
        lat: latitude,
        lng: longitude,
      };
      self.markers[0].position.lat = latitude;
      self.markers[0].position.lng = longitude;
      hfullAddress = hfullAddress.replace(/\s+/g, "+");
      axios
        .get(
          "https://maps.googleapis.com/maps/api/geocode/json?address=" +
            hfullAddress +
            "&key=AIzaSyArGgueGCb2p4sqjU4pScADLskS9OxZ8jQ"
        )
        .then((response) => {
          // Ideally you'd search for the index with type = sublocality in address_components
          this.fillAddress(response.data.results);
        });
    },

    goback() {
      sessionStorage.clear();
      this.$router.go();
    },

    backToProdList() {
      this.isFinalCart = false;
      this.isProdListCardShow = true;
      (this.couponAppliedMsg = ""),
        (this.errorMsg = ""),
        (this.isCouponApplied = false);
      this.noError = true;
      this.scrollToTop();
    },

    bellStatusChange(event) {
      this.ringOnNotSelected = false;
      this.ringOnSelected = false;
      this.ringOffNotSelected = false;
      this.ringOffSelected = false;
      let bellId = event.toElement.id;
      // console.log(event)
      if (bellId === "ring_on_not_selected") {
        this.ringOnNotSelected = false;
        this.ringOnSelected = true;
        this.ringOffNotSelected = true;
        this.ringOffSelected = false;
      } else if (bellId === "ring_on_selected") {
        this.ringOnNotSelected = false;
        this.ringOnSelected = true;
        this.ringOffNotSelected = true;
        this.ringOffSelected = false;
      } else if (bellId === "ring_on_not_selected") {
        this.ringOnNotSelected = true;
        this.ringOnSelected = false;
        this.ringOffNotSelected = false;
        this.ringOffSelected = true;
      } else {
        this.ringOnNotSelected = true;
        this.ringOnSelected = false;
        this.ringOffNotSelected = false;
        this.ringOffSelected = true;
      }
    },

    getProductList() {
      var session = sessionStorage.getItem("paymentFlow");
      if (sessionStorage.getItem("paymentFlow") === "order") {
        //debugger
        this.userId = sessionStorage.getItem("userId");
        this.subscription_type = sessionStorage.getItem("sub_type");
        this.updatedCart = sessionStorage.getItem("updatedCart");
        this.updatedCart = JSON.parse(this.updatedCart);
        this.ringOnSelected = sessionStorage.getItem("ringOnSelected");
        this.start_date = sessionStorage.getItem("start_date");
        this.reqWallAmt = sessionStorage.getItem("required_wallet_amount");
        this.isProdListCardShow = false;
        sessionStorage.clear();
        //debugger
        const params = new URLSearchParams();
        params.append("user_id", this.userId);
        axios({
          url: this.apiUrl + "doodhvale/api/web/v3/accounts/account-view",
          method: "post",
          data: params,
          withCredentials: false,
          headers: {},
        })
          .then((response) => {
            this.isLoading = false;
            if (response.data.status === "000000") {
              if (response.data.display_title === "Wallet Balance") {
                if (response.data.pending_amount * -1 >= this.reqWallAmt) {
                  this.submitCart();
                } else {
                  this.$swal({
                    customClass: {
                      popup: "custom-swal-popup",
                      confirmButton:
                        "mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn",
                    },
                    text:
                      "Your product is not subscribe beacuse you have insufficient wallet balance to subscribe",
                    allowOutsideClick: false,
                  }).then((result) => {
                    if (result.value) {
                      this.$router.go();
                    } else {
                    }
                  });
                }
              } else {
                this.$swal({
                  customClass: {
                    popup: "custom-swal-popup",
                    confirmButton:
                      "mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn",
                  },
                  text:
                    "Your product is not subscribe beacuse you have insufficient wallet balance to subscribe",
                  allowOutsideClick: false,
                }).then((result) => {
                  if (result.value) {
                    this.$router.go();
                  } else {
                  }
                });
              }
              /* if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
              } */
            } else {
              this.$swal({
                customClass: {
                  popup: "custom-swal-popup",
                  confirmButton:
                    "mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn",
                },
                text: "Something went wrong, Try Again!",
                allowOutsideClick: false,
              }).then((result) => {
                if (result.value) {
                  this.$router.go();
                } else {
                }
              });
            }
          })
          .catch((e) => {
            //alert('not ok')
          });
      } else {
        let params = new URLSearchParams();
        params.append("user_id", 451);
        params.append("cat_id", 2);
        this.tomorrow = new Date();
        axios
          .post(
            this.apiUrl +
              "doodhvale/api/web/v3/products/products-with-pre-post-price",
            params
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            this.products = response.data.product_list;
            // debugger
            var prodList = JSON.parse(sessionStorage.getItem("products"));
            if (prodList) {
              this.products = prodList;
              this.total_product_quantity = Number(
                sessionStorage.getItem("total_product_quantity")
              );
              this.total_price_before_discount = Number(
                sessionStorage.getItem("total_price_before_discount")
              );
              this.total_price_after_discount = Number(
                sessionStorage.getItem("total_price_after_discount")
              );
            }
            this.isPrepaidOnly = response.data.prepaid_feature_only;
            //this.tomorrow.setDate(this.tomorrow.getDate() + 1)
            //this.tomorrowplus1 =  new Date(this.tomorrow)
            //this.tomorrowplus1.setDate(this.tomorrow.getDate() + 2)
            //this.tomorrowplus2 = new Date(this.tomorrowplus1)
            //this.tomorrowplus2.setDate(this.tomorrowplus1.getDate() + 1)
            this.tomorrow = new Date(response.data.tomorrow);
            this.tomorrowplus1 = new Date(response.data.dayAfterTomorrow);
            this.tomorrowplus2 = new Date(response.data.TwoDayAfterTomorrow);
            this.days = 1;
            this.options = [
              {
                text: "Tomorrow",
                value: this.tomorrow.toISOString().slice(0, 10),
              },
              {
                text: this.convertDate(
                  this.tomorrowplus1.toISOString().slice(0, 10)
                ),
                value: this.tomorrowplus1.toISOString().slice(0, 10),
              },
              {
                text: this.convertDate(
                  this.tomorrowplus2.toISOString().slice(0, 10)
                ),
                value: this.tomorrowplus2.toISOString().slice(0, 10),
              },
            ];
            this.start_date = this.tomorrow.toISOString().slice(0, 10);

            this.isLoading = false;
          })
          .catch((e) => {});
      }
    },
    signup() {
      const params = new URLSearchParams();
      var mobile = this.mobile;
      var deviceID = this.mobile;
      // debugger
      if (!this.validMobileForm()) {
        return;
      } else {
        // this.isLoading = true
        params.append("mobile", mobile);
        params.append("app_type", "web");
        //this.isSignUp = true
        //params.append('deviceId', deviceID)
        axios({
          url: this.apiUrl + "doodhvale/api/web/v3/users/signup",
          method: "post",
          data: params,
          withCredentials: false,
          headers: {},
        })
          .then((response) => {
            // this.isLoading = false
            if (
              response.data.status === "000000" ||
              response.data.status === "000001" ||
              response.data.status === "000002" ||
              response.data.status === "000007" ||
              response.data.status === "000012"
            ) {
              //this.isSignUp = true
              if (
                response.data.status === "000000" &&
                response.data.is_profile === 1
              ) {
                // first login case
                this.resendotp();
                this.isSignUp = true;
                this.scrollToTop();
              } else {
                this.resendotp();
                this.isSignUp = true;
                this.scrollToTop();
              }
            } else {
              this.$swal({
                customClass: {
                  popup: "custom-swal-popup",
                  confirmButton:
                    "mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn",
                },
                text: response.data.msg,
                allowOutsideClick: false,
              });
            }
            // console.log(response)
            /* if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
              this.list = response.data.user_record
              //alert(this.list)
            } */
          })
          .catch((e) => {
            // alert('not ok')
          });
      }
    },

    resendotp() {
      const params = new URLSearchParams();
      params.append("mobile", this.mobile);
      axios({
        url: this.apiUrl + "doodhvale/api/web/v3/users/resend-otp",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          if (response.data.status !== "000000") {
            //alert(response.data.msg)
          }
          // console.log(response)
          /* if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            //alert(this.list)
          } */
        })
        .catch((e) => {
          //alert('not ok')
        });
    },

    verifyotp() {
      // debugger
      if (!this.validOTPForm()) {
        return;
      } else {
        // this.isLoading = true
        const params = new URLSearchParams();
        var otp = this.otp;
        var mobile = this.mobile;
        params.append("otp", otp);
        params.append("mobile", mobile);
        axios({
          url: this.apiUrl + "doodhvale/api/web/v3/users/verify-otp",
          method: "post",
          data: params,
          withCredentials: false,
          headers: {},
        })
          .then((response) => {
            // this.isLoading=false
            if (response.data.status === "000000") {
              this.userId = response.data.user_id;
              this.is_profile = response.data.is_profile;
              this.getUserInfo();
              this.isMobileVerified = true;
              this.isAddressCard = true;
              this.isMobCardShow = false;
              this.scrollToTop();
            } else {
              this.$swal({
                customClass: {
                  popup: "custom-swal-popup",
                  confirmButton:
                    "mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn",
                },
                text: response.data.msg,
                allowOutsideClick: false,
              });
            }
            // console.log(response)
            /* if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
              this.list = response.data.user_record
              //alert(this.list)
            } */
          })
          .catch((e) => {
            //alert('not ok')
          });
      }
    },

    finalCart() {
      var products = this.products;
      var sub_type = this.subscription_type;
      var cart = [];

      this.products.forEach(function(product) {
        if (product["quantity"] > 0) {
          var temp = {};
          if (sub_type == "Prepaid") {
            temp.product_price = product["prepaid_price"];
          } else {
            temp.product_price = product["postpaid_price"];
          }
          temp.subscription_id = product.subscription_id;
          temp.product_id = product.product_id;
          temp.quantity = product.quantity;
          temp.product_name = product.product_name;
          temp.product_quantity = product.product_price_list[0].quantity;
          temp.mrp = product.product_price_list[0].mrp;
          temp.product_unit = product.product_price_list[0].unit;
          temp.subscription_type = sub_type;
          temp.delivery_frequency = "3";
          temp.type = product.subscription_type;
          temp.img = product.product_image_s3_url;  //sanya: adding image link to cart
          cart.push(temp);
        }
      });
      this.cart = cart;
    },

    submitCart() {
      // debugger
      var cart = this.updatedCart;
      cart = JSON.stringify(cart);
      const params = new URLSearchParams();

      if (this.ringOnSelected === true) {
        params.append("is_ring_bell", 1);
      } else {
        params.append("is_ring_bell", 0);
      }
      params.append("user_id", this.userId);
      params.append("cart", cart);
      params.append("start_date", this.start_date);

      axios({
        url:
          this.apiUrl + "doodhvale/api/web/v3/subscriptions/multi-subscription",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          if (response.data.status === "000000") {
            this.isFinalCart = false;
            //myself = this
            sessionStorage.clear();
            sessionStorage.setItem("referrerPage", "order");
            if (this.subscription_type == "Prepaid") {
              const params = new URLSearchParams();
              params.append("user_id", this.userId);
              axios({
                url:
                  this.apiUrl +
                  "doodhvale/api/web/v3/accounts/last-online-transaction",
                method: "post",
                data: params,
                withCredentials: false,
                headers: {},
              })
                .then((response) => {
                  if (response.data.status === "000000") {
                    sessionStorage.setItem("cart", cart);   //sanya: sending cart to ThankYou.vue to acess product details
                    sessionStorage.setItem("start_date",this.start_date);   //sanya: sending start_date to ThankYou.vue
                    ga("require", "ecommerce");
                    //sanya: commenting out the following code so user is redirected to Thank You page after payment
                    // ga("ecommerce:addTransaction", {
                    //   id: response.data.transaction_list.order_id,
                    //   revenue: response.data.transaction_list.amount,
                    // });
                    ga("ecommerce:send");
                    this.$router.push("/thank-you");
                  } else {
                  }
                })
                .catch((e) => {
                  //alert('not ok')
                });
            } else {
              this.$router.push("/thank-you");
            }

            /*this.$swal({
            icon: 'success',
            customClass: {
            popup: 'custom-swal-popup',
            confirmButton:'mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn'
            },
            text: 'Congrats! You Have Subscribe Successfully',
            allowOutsideClick: false
            }).then((result) => {
              if (result.value) {
              this.$router.go()
              sessionStorage.clear()
              } else {
              }
              })*/
          } else {
            this.isFinalCart = false;
            // debugger
            this.isInformationalCard = true;
            this.updatedProdList = response.data.updated_prod_list;
          }
        })
        .catch((e) => {
          //alert('not ok')
        });
    },

    fetchData() {
      const params = new URLSearchParams();
      var fullUrl = this.payment_url;
      var splitUrl = fullUrl.split("pp?");
      params.append("url_str", splitUrl[1]);
      axios({
        url:
          this.apiUrl +
          "doodhvale/api/web/v3/accounts/fetch-url-interface-data",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          this.urlInterface = {};
          if (
            response.data.status === "000001" ||
            response.data.status === "000002" ||
            response.data.status === "000003"
          ) {
            this.urlInterface.error_msg = response.data.msg;
            if (document.getElementById("url_valid") !== null) {
              document.getElementById("url_valid").style.display = "none";
            }
          } else {
            if (document.getElementById("url_expired") !== null) {
              document.getElementById("url_expired").style.display = "none";
            }
            this.urlInterface.action_name = response.data.action_name;
            this.urlInterface.url_interface_id = response.data.url_interface_id;
            this.urlInterface.vue_url = this.vueUrl;
            this.urlInterface.callback_url =
              this.apiUrl +
              "doodhvale/api/modules/v3" +
              "/controllers/pgResponse.php";
            var see = this.urlInterface.callback_url;
            this.invokeUrlAction();
          }
          // console.log(response)
          /* if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            //alert(this.list)
          } */
          setTimeout(() => {
            if (document.getElementById("bafore_checksum") !== null) {
              document.getElementById("bafore_checksum").style.display =
                "block";
            }
            this.isLoading = false;
          }, 10000);
        })
        .catch((e) => {
          if (document.getElementById("bafore_checksum") !== null) {
            document.getElementById("bafore_checksum").style.display = "block";
          }
          this.isLoading = false;
          //alert('not ok')
        });
    },

    invokeUrlAction() {
      const params = new URLSearchParams();
      params.append("url_interface_id", this.urlInterface.url_interface_id);
      params.append("action_name", this.urlInterface.action_name);
      axios({
        url: this.apiUrl + "doodhvale/api/web/v3/accounts/invoke-url-action",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          if (
            response.data.action_response.user_id === null ||
            response.data.action_response.user_id === 0 ||
            response.data.action_response.user_id === "0" ||
            response.data.action_response.user_id === "undefined"
          ) {
            window.location.reload();
          }
          this.apiDataObj = {};
          switch (this.urlInterface.action_name) {
            case "cow_milk_bill":
              // for cow milk billing
              break;
            case "pending_bill_payment":
              // console.log(response)
              this.apiDataObj.userId = response.data.action_response.user_id;
              this.apiDataObj.payment_gateway =
                response.data.action_response.payment_gateway;
              // this.apiDataObj.app_payment_gateway = response.data.action_response.app_payment_gateway
              // ///////// start for payment option //////
              this.apiDataObj.cc = response.data.action_response.app_payment_cc;
              this.apiDataObj.upi =
                response.data.action_response.app_payment_upi;
              this.apiDataObj.paytm =
                response.data.action_response.app_payment_wallet_paytm;
              this.apiDataObj.mobikwik =
                response.data.action_response.app_payment_wallet_mobikwik;
              this.apiDataObj.ola =
                response.data.action_response.app_payment_wallet_olamoney;
              this.apiDataObj.jio =
                response.data.action_response.app_payment_wallet_jiomoney;
              this.apiDataObj.freecharge =
                response.data.action_response.app_payment_wallet_freecharge;
              // ///////// end for payment option //////
              this.apiDataObj.pending_amount = Math.ceil(
                response.data.action_response.pending_amount
              );
              // console.log(response.data.action_response.is_quick_payment_button_display)
              this.isQuickPaymentButtonDisplay =
                response.data.action_response.is_quick_payment_button_display;
              if (this.isQuickPaymentButtonDisplay === 0) {
                this.fiveDeliveryAmount =
                  response.data.action_response.five_deliveries_amount;
                this.sevenDeliveryAmount =
                  response.data.action_response.seven_deliveries_amount;
                this.fifteenDeliveryAmount =
                  response.data.action_response.fifteen_deliveries_amount;
                this.thirtyDeliveryAmount =
                  response.data.action_response.thirty_deliveries_amount;
                this.fourtyFiveDeliveryAmount =
                  response.data.action_response.fourty_five_deliveries_amount;
                this.sixtyDeliveryAmount =
                  response.data.action_response.sixty_deliveries_amount;
                this.ninetyDeliveryAmount =
                  response.data.action_response.ninety_deliveries_amount;
              }
              // this.apiDataObj.pending_amount = -5
              this.apiDataObj.wallet_amount = 0;
              if (this.apiDataObj.pending_amount > 0) {
                if (document.getElementById("not_pending") !== null) {
                  document.getElementById("not_pending").style.display = "none";
                }
                if (document.getElementById("clear") !== null) {
                  document.getElementById("clear").style.display = "none";
                }
              } else {
                if (document.getElementById("pending") !== null) {
                  document.getElementById("pending").style.display = "none";
                }
                if (document.getElementById("clear") !== null) {
                  document.getElementById("clear").style.display = "none";
                }
                this.apiDataObj.wallet_amount = Math.abs(
                  this.apiDataObj.pending_amount
                );
                this.apiDataObj.pending_amount = 0;
              }
              this.apiDataObj.default_amount = this.apiDataObj.pending_amount;
              //this.pendingBillPayment()
              break;
            case "order_flow_payment":
              // console.log(response)
              this.apiDataObj.userId = response.data.action_response.user_id;
              this.apiDataObj.payment_gateway =
                response.data.action_response.payment_gateway;
              // this.apiDataObj.app_payment_gateway = response.data.action_response.app_payment_gateway
              // ///////// start for payment option //////
              this.apiDataObj.cc = response.data.action_response.app_payment_cc;
              this.apiDataObj.upi =
                response.data.action_response.app_payment_upi;
              this.apiDataObj.paytm =
                response.data.action_response.app_payment_wallet_paytm;
              this.apiDataObj.mobikwik =
                response.data.action_response.app_payment_wallet_mobikwik;
              this.apiDataObj.ola =
                response.data.action_response.app_payment_wallet_olamoney;
              this.apiDataObj.jio =
                response.data.action_response.app_payment_wallet_jiomoney;
              this.apiDataObj.freecharge =
                response.data.action_response.app_payment_wallet_freecharge;
              // ///////// end for payment option //////
              this.apiDataObj.pending_amount = Math.ceil(
                response.data.action_response.pending_amount
              );
              this.apiDataObj.default_amount = Math.ceil(
                response.data.action_response.default_amount
              );
              // this.apiDataObj.pending_amount = -5
              this.apiDataObj.wallet_amount = 0;
              if (this.apiDataObj.pending_amount > 0) {
                if (document.getElementById("not_pending") !== null) {
                  document.getElementById("not_pending").style.display = "none";
                }
                if (document.getElementById("clear") !== null) {
                  document.getElementById("clear").style.display = "none";
                }
              } else {
                if (document.getElementById("pending") !== null) {
                  document.getElementById("pending").style.display = "none";
                }
                if (document.getElementById("clear") !== null) {
                  document.getElementById("clear").style.display = "none";
                }
                this.apiDataObj.wallet_amount = Math.abs(
                  this.apiDataObj.pending_amount
                );
                this.apiDataObj.pending_amount = 0;
              }
              //this.pendingBillPayment()
              break;
            default:
              break;
          }
          /* if (this.apiDataObj.default_amount > 0) {
            this.btnOneValue = ((parseInt(this.apiDataObj.default_amount / 500)) + 1) * 500
            this.btnTwoValue = this.btnOneValue + 500
            this.btnThreeValue = this.btnOneValue + 1000
          }*/
          // console.log(response)
          /* if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
           // alert(this.list)
          } */
          // this.isFinalCart = false
          // this.isPaymentCard = true
        })
        .catch((e) => {
          //alert('not ok')
        });
    },

    btnOneClick() {
      document.getElementById("txn_amt").value = this.btnOneValue;
    },

    btnTwoClick() {
      document.getElementById("txn_amt").value = this.btnTwoValue;
    },

    btnThreeClick() {
      document.getElementById("txn_amt").value = this.btnThreeValue;
    },
    btnFourClick() {
      document.getElementById("txn_amt").value = this.btnFourValue;
    },

    fiveDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.fiveDeliveryAmount;
    },

    sevenDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.sevenDeliveryAmount;
    },

    fifteenDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.fifteenDeliveryAmount;
    },

    thirtyDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.thirtyDeliveryAmount;
    },

    fourtyFiveDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.fourtyFiveDeliveryAmount;
    },

    sixtyDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.sixtyDeliveryAmount;
    },

    ninetyDeliveryBtnClick() {
      document.getElementById("txn_amt").value = this.ninetyDeliveryAmount;
    },

    onAmmountChange() {
      this.errors = "";
      this.isActive = false;
      document.getElementById("txn_amt").value = Number(
        document.getElementById("txn_amt").value
      );
    },
    generateChecksum() {
      sessionStorage.setItem("paymentFlow", "order");
      sessionStorage.setItem("userId", this.userId);
      //this.cart = JSON.stringify(this.cart)
      sessionStorage.setItem("updatedCart", JSON.stringify(this.updatedCart));
      sessionStorage.setItem("ringOnSelected", this.ringOnSelected);
      sessionStorage.setItem("sub_type", this.subscription_type);
      sessionStorage.setItem("start_date", this.start_date);
      sessionStorage.setItem("required_wallet_amount", this.reqWallAmt);
      var paymentType = "2";
      switch (this.payment_type) {
        case "cc":
          paymentType = this.apiDataObj.cc;
          break;
        case "upi":
          paymentType = this.apiDataObj.upi;
          break;
        case "paytm":
          paymentType = this.apiDataObj.paytm;
          break;
        case "mobikwik":
          paymentType = this.apiDataObj.mobikwik;
          break;
        case "ola":
          paymentType = this.apiDataObj.ola;
          break;
        case "jio":
          paymentType = this.apiDataObj.jio;
          break;
        case "freecharge":
          paymentType = this.apiDataObj.freecharge;
          break;
        default:
      }
      this.apiDataObj.app_payment_gateway = paymentType;
      if (paymentType === "1") {
        this.paytm();
      } else {
        if (this.apiDataObj.app_payment_gateway === "1") {
          this.paytm();
        } else {
          this.hdfc();
        }
      }
    },
    paytm() {
      //debugger
      var orderId = "";
      const params = new URLSearchParams();
      var userId = this.apiDataObj.userId;
      params.append("user_id", userId);
      params.append("gateway_name", "paytm");
      axios({
        url:
          this.apiUrl +
          "doodhvale/api/web/v3/accounts/generate-unique-order-id",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          if (response.data.msg.trim().toUpperCase() === "SUCCESS") {
            orderId = response.data.unique_order_id;
            const params = new URLSearchParams();
            // var userId = this.apiDataObj.userId
            // var txnAmount = document.getElementById('txn_amt').value
            var txnAmount = this.rechargeAmt;
            if (isNaN(txnAmount) || txnAmount <= 0 || txnAmount === "") {
              document.getElementById("txn_amt").focus();
              this.errors = "Oops! Invalid Amount.";
              this.isActive = true;
            } else {
              this.isLoading = true;
              // var orderId = 'DVWP' + Math.floor(Math.random() * 10000000)
              params.append("CUST_ID", userId);
              params.append("ORDER_ID", orderId);
              params.append("CHANNEL_ID", "WEB");
              params.append("WEBSITE", "SanjeeWEB");
              // params.append('WEBSITE', 'APP_STAGING')// staging
              params.append("TXN_AMOUNT", txnAmount);
              params.append(
                "MERC_UNQ_REF",
                userId +
                  "br" +
                  this.urlInterface.vue_url +
                  "br" +
                  this.apiUrl +
                  "doodhvale/api/web/v3" +
                  "/accounts/verify-transaction"
              );
              params.append("CALLBACK_URL", this.urlInterface.callback_url);
              axios({
                url:
                  this.apiUrl +
                  "doodhvale/api/web/v3" +
                  "/accounts/generate-checksum",
                method: "post",
                data: params,
                withCredentials: false,
                headers: {},
              })
                .then((response) => {
                  this.genChecksum = {};
                  this.genChecksum.MID = response.data.post_value.MID;
                  this.genChecksum.ORDER_ID = response.data.post_value.ORDER_ID;
                  this.genChecksum.CUST_ID = response.data.post_value.CUST_ID;
                  this.genChecksum.INDUSTRY_TYPE_ID =
                    response.data.post_value.INDUSTRY_TYPE_ID;
                  this.genChecksum.CHANNEL_ID =
                    response.data.post_value.CHANNEL_ID;
                  this.genChecksum.WEBSITE = response.data.post_value.WEBSITE;
                  this.genChecksum.TXN_AMOUNT =
                    response.data.post_value.TXN_AMOUNT;
                  this.genChecksum.CALLBACK_URL =
                    response.data.post_value.CALLBACK_URL;
                  this.genChecksum.MERC_UNQ_REF =
                    response.data.post_value.MERC_UNQ_REF;
                  this.genChecksum.checksum = response.data.checkSum;
                  this.isFinalCart = true;    //sanya: removes blank page while redirecting
                  this.isPaymentCard = true;
                  this.app_payment_gate = false;
                  this.userData = false;
                  this.after_checksum = true;
                  setTimeout(function() {
                    document.getElementById("paytmFormSubmit").submit();
                  }, 300);

                  /* console.log(response)
                  if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
                    this.list = response.data.user_record
                    alert(this.list)
                  } */
                })
                .catch((e) => {
                  //alert('not ok')
                });
              this.isLoading = false;
            }
          }
        })
        .catch((e) => {
          this.errors = "Server error, Try again!";
          this.isActive = true;
        });
    },
    hdfc() {
      var orderId = "";
      var userId = this.apiDataObj.userId;
      const params = new URLSearchParams();
      params.append("user_id", userId);
      params.append("gateway_name", "hdfc");
      axios({
        url:
          this.apiUrl +
          "doodhvale/api/web/v3/accounts/generate-unique-order-id",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          if (response.data.msg.trim().toUpperCase() === "SUCCESS") {
            orderId = response.data.unique_order_id;
            // var userId = this.apiDataObj.userId
            var txnAmount = Number(this.rechargeAmt);
            if (isNaN(txnAmount) || txnAmount <= 0 || txnAmount === "") {
              document.getElementById("txn_amt").focus();
              this.errors = "Oops! Invalid Amount.";
              this.isActive = true;
            } else {
              this.isLoading = true;
              this.appPaymentGateway = {};
              this.appPaymentGateway.TXN_AMOUNT = txnAmount;
              this.appPaymentGateway.ORDER_ID = orderId; // 'DVWH' + Math.floor(Math.random() * 10000000)
              this.appPaymentGateway.TID = new Date().getTime();
              this.appPaymentGateway.CALLBACK_URL = this.urlInterface.vue_url;
              this.appPaymentGateway.APP_PAYMENT_GATEWAY = this.apiDataObj.app_payment_gateway;
              this.appPaymentGateway.actionUrl =
                this.apiUrl +
                "doodhvale/api/modules/v3" +
                "/controllers/ccavRequestHandler.php";
              this.appPaymentGateway.responseUrl =
                this.apiUrl +
                "doodhvale/api/modules/v3" +
                "/controllers/ccavResponseHandler.php";
              this.appPaymentGateway.apiUrl =
                this.apiUrl +
                "doodhvale/api/web/v3" +
                "/accounts/payment-gateway-transaction";
              this.isFinalCart = true;      //sanya: removes blank page while redirecting
              this.isPaymentCard = true;
              this.after_checksum = false;
              this.userData = false;
              this.app_payment_gate = true;
              setTimeout(function() {
                document.getElementById("hdfcFormSubmit").submit();
              }, 300);
            }
          }
        })
        .catch((e) => {
          this.errors = "Server error, Try again!";
          this.isActive = true;
        });

      this.isLoading = false;
    },
    isNumber: function(evt) {
      if (!evt) {
        evt = window.event;
      }
      // evt = (evt) ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    loadPaymentGatewayData() {
      // debugger
      const params = new URLSearchParams();
      // this.isLoading = true
      params.append("action_name", "order_flow_payment_url");
      params.append("user_id", this.userId);
      params.append("required_amount", this.rechargeAmt);
      axios({
        url: this.apiUrl + "doodhvale/api/web/v3" + "/users/invoke-user-action",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          // console.log(response)
          this.payment_url = response.data.payment_url;
          this.fetchData();
        })
        .catch((e) => {
          //alert('not ok')
        });
    },

    verifySubscription() {
      // debugger
      this.isLoading = true;
      var cart = this.cart;
      cart = JSON.stringify(cart);
      const params = new URLSearchParams();

      if (this.ringOnSelected === true) {
        params.append("is_ring_bell", 1);
      } else {
        params.append("is_ring_bell", 0);
      }
      params.append("user_id", this.userId);
      params.append("cart", cart);
      params.append("start_date", this.start_date);
      params.append("total_cart_value", this.total_price_after_discount);

      axios({
        url:
          this.apiUrl +
          "doodhvale/api/web/v3/subscriptions/multi-subscription-verification",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          // debugger
          if (response.data.status_code === "000000") {
            // this.submitCart()
            this.walletBal = response.data.walletBal;
            var cart = response.data.cart;
            this.updatedCart = JSON.parse(cart);
            this.rechargeAmt = 0;
            this.updatedCartTotal = response.data.totalCartValue;
            // debugger
          } else if (response.data.status_code == "000005") {
            // alert(str)
            //  this.$swal({
            //       text: response.data.msg,
            //       showCancelButton: true,
            //       customClass: 'custom-swal',
            //       confirmButtonColor: "#3085d6",
            //       confirmButtonText: "Recharge",
            //       confirmButtonColor: "#3085d6",
            //       cancelButtonText: 'Cancel',
            //       allowOutsideClick: false
            //   }).then((result) => {
            this.reqWallAmt = response.data.totalRequiredWalletAmt;
            this.rechargeAmt = response.data.rechargeAmt;
            this.msg = response.data.msg;
            this.walletBal = response.data.walletBal;
            this.updatedCart = JSON.parse(response.data.cart);
            this.updatedCartTotal = response.data.totalCartValue;
            // if (result.value) {
            // debugger
            this.loadPaymentGatewayData();
            // } else {
            //   // this.$swal('Success', 'Thanks you Replan!', 'success')
            // }
            // })
            // } else {
            //   // alert(response.data.msg)
            //   // alert(str)
            //   this.$swal({
            //     text: str + '!',
            //     customClass: 'custom-swal',
            //     showCancelButton: false,
            //     confirmButtonText: 'Okay',
            //     allowOutsideClick: false
            //     // showCloseButton: true,
            //     // showLoaderOnConfirm: true
            //   }).then((result) => {})
          }
          if (response.data.noError === false) {
            if (document.getElementById("add-and-continue")) {
              document.getElementById("add-and-continue").style.display =
                "none";
            }
            if (document.getElementById("place-order")) {
              document.getElementById("place-order").style.display = "none";
            }
            if (document.getElementById("payment-method")) {
              document.getElementById("payment-method").style.display = "none";
            }
            if (document.getElementById("wallet-balance")) {
              document.getElementById("wallet-balance").style.display = "none";
            }
            this.noError = response.data.noError;
            this.isShowErrorMsg = true;
            this.errorMsg = response.data.errorMsg;
            this.couponAppliedMsg = "";
          } else if (
            response.data.noError === true &&
            response.data.isCouponApplied === true &&
            response.data.couponAppliedMsg != ""
          ) {
            this.isCouponApplied = true;
            this.noError = response.data.noError;
            this.couponAppliedMsg = response.data.couponAppliedMsg;
          }
          this.isLoading = false;
        })
        .catch((e) => {
          //alert('not ok')
        });
    },
    handleOnComplete(value) {
      this.otp = value;
    },

    handleOnChange(value) {},

    // handleClearInput() {
    //   this.$refs.otpInput.clearInput();
    // },

    updateProfileAddress() {
      // debugger
      if (document.getElementById("headerLat").value === "") {
        this.editLocation();
        setTimeout(function() {
          document.getElementById("madal-error-address").style.display =
            "block";
        }, 100);
        // document.getElementById('madal-error-address').style.display = 'block
        return;
      }
      if (!this.validate() == true) {
        return;
      }
      // debugger
      this.searchAddress = document.getElementById("searchAddress").innerHTML;
      if (
        this.userDetails.first_name === "" ||
        this.userDetails.first_name === undefined
      ) {
        this.$swal({
          customClass: {
            popup: "custom-swal-popup",
            confirmButton:
              "mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn",
          },
          text: "Please Enter Name",
          allowOutsideClick: false,
        });
        return;
      }
      // if(this.userDetails.email === '' || this.userDetails.email === undefined ){
      //   this.$swal({
      //       customClass: 'custom-swal',
      //       text: "Please Enter Email",
      //       allowOutsideClick: false
      //     })
      //     return
      // }
      if (document.getElementById("address1").value !== "") {
        this.address1 = document.getElementById("address1").value;
        this.address2 = document.getElementById("address2").value;
        //if (sessionStorage.getItem('actionName') === 'subscription') {
        const params = new URLSearchParams();
        var userDetails = this.userDetails;
        this.userDetails.fullName = userDetails.first_name;
        this.custName = userDetails.first_name;
        // if (document.getElementById('searchAddress').innerHTML == '' /*|| this.formattedAddress == ''*/) {
        //   this.userDetails.address = this.address1 + ' ' + this.address2 + ', ' + this.city + ', ' + this.state + ', ' + this.pincode
        // }else{
        this.userDetails.address =
          this.address1 +
          ", " +
          document.getElementById("searchAddress").innerHTML;
        this.formattedAddress = document.getElementById(
          "searchAddress"
        ).innerHTML;
        this.markers[0].position.lat = document.getElementById(
          "headerLat"
        ).value;
        this.markers[0].position.lng = document.getElementById(
          "headerLng"
        ).value;
        //  this.fillAddress(this.markers[0].position.lat,this.markers[0].position.lng)
        //}
        // debugger
        this.custAddress = this.userDetails.address;
        params.append("user_id", this.userId);
        params.append("first_name", this.userDetails.first_name);
        params.append("pincode", this.pincode);
        params.append("address1", this.address1);
        params.append("address2", this.address2);
        params.append("state", this.state);
        params.append("gps_address", this.formattedAddress);
        // if (this.markers[0].position.lat) {
        params.append("latitude", this.markers[0].position.lat);
        params.append("longitude", this.markers[0].position.lng);
        // } else {
        //   params.append('latitude', 0.0)
        //   params.append('longitude', 0.0)
        // }
        params.append("locality", this.locality);
        params.append("region_code", this.pincode);
        params.append("phone", this.mobile);
        params.append("email", this.userDetails.email);
        params.append("zombie", 0);
        params.append("country_id", 1);
        //debugger
        axios({
          url: this.apiUrl + "doodhvale/api/web/v3/users/profile",
          method: "post",
          data: params,
          withCredentials: false,
          headers: {},
        })
          .then((response) => {
            // console.log(response)
            if (response.data.status === "000000") {
              // window.location.href = sessionStorage.getItem('callbackUrlForSubscription')
              // debugger
              this.finalCart();
              // if (this.subscription_type=='Prepaid'){
              this.verifySubscription();
              // }
              this.isAddressCard = false;
              this.isFinalCart = true;
              document.getElementById("login-user").innerHTML =
                "welcome, " + userDetails.first_name;
              localStorage.setItem(
                "databaseSavedLat",
                this.markers[0].position.lat
              );

              this.scrollToTop();
            } else {
              this.$swal({
                customClass: {
                  popup: "custom-swal-popup",
                  confirmButton:
                    "mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn",
                },
                text: response.data.msg,
                allowOutsideClick: false,
              });
            }
          })
          .catch((e) => {
            //console.log(e)
          });
      } else {
        // alert('Please fill address')
        this.$swal({
          customClass: {
            popup: "custom-swal-popup",
            confirmButton:
              "mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn",
          },
          text: "Please Enter H. NO | FLOOR | LOCALITY | AREA!",
          allowOutsideClick: false,
        });
      }
      this.saveLocalStorageData();
    },

    getUserInfo() {
      const params = new URLSearchParams();
      params.append("user_id", this.userId);
      axios({
        url: this.apiUrl + "doodhvale/api/web/v3/users/user-info",
        method: "post",
        data: params,
        withCredentials: false,
        headers: {},
      })
        .then((response) => {
          // debugger
          if (response.data.status == "000000") {
            var self = this;
            var loginUser = "";
            if (self.is_profile === 0) {
              self.userDetails = response.data.user_record.user_details;
              //var see = document.getElementById('logout-menu-header')
              document.getElementById("logout-menu").style.display = "block";
              document.getElementById("f-logout").style.display = "block";
              if (self.userDetails.first_name) {
                loginUser = self.userDetails.first_name;
              }
              document.getElementById("login-user").innerHTML =
                "welcome, " + loginUser;
              // document.getElementById('logout-menu-header').innerText = response.data.user_record.user_details.first_name
              self.userDetails.fullName =
                response.data.user_record.user_details.first_name +
                " " +
                response.data.user_record.user_details.last_name;
              self.address1 = response.data.user_record.address.address1;
              self.address2 = response.data.user_record.address.address2;
              self.city = response.data.user_record.address.city;
              self.userDetails.city = response.data.user_record.address.city;
              self.userDetails.state = response.data.user_record.address.state;
              self.userDetails.address =
                self.address1 +
                " " +
                self.address2 +
                " " +
                self.userDetails.city +
                " " +
                self.userDetails.state +
                " " +
                self.userDetails.pincode;
              self.custName = self.userDetails.fullName;
              self.custAddress = self.userDetails.address;
              self.userDetails.fullName = self.userDetails.fullName.replace(
                /[^a-zA-Z0-9 ]/g,
                ""
              );
              self.userDetails.address = self.userDetails.address.replace(
                /[^a-zA-Z0-9 ]/g,
                ""
              );
              self.markers[0].position.lat = parseFloat(
                response.data.user_record.address.latitude
              );
              self.markers[0].position.lng = parseFloat(
                response.data.user_record.address.longitude
              );
              self.center.lat = parseFloat(
                response.data.user_record.address.latitude
              );
              self.center.lng = parseFloat(
                response.data.user_record.address.longitude
              );
              document.getElementById("headerLat").value =
                self.markers[0].position.lat;
              document.getElementById("headerLng").value =
                self.markers[0].position.lng;
              document.getElementById("hfullAddress").value =
                response.data.user_record.address.gps_address;
              self.address(
                self.markers[0].position.lat,
                self.markers[0].position.lng
              );
              if (document.getElementById("searchAddress")) {
                document.getElementById("searchAddress").innerHTML =
                  response.data.user_record.address.gps_address;
              }
            } else {
              document.getElementById("logout-menu").style.display = "block";
              document.getElementById("f-logout").style.display = "block";
              document.getElementById("login-user").innerHTML =
                "welcome, " + this.mobile;
              if (document.getElementById("headerLat").value !== "") {
                // debugger
                this.populateAddressForm();
              } else {
                this.currentlocation();
              }
            }
            this.isLoading = false;
          } else {
            if (document.getElementById("headerLat")) {
              let latitude = document.getElementById("headerLat").value;
              let longitude = document.getElementById("headerLng").value;
              let hfullAddress = document.getElementById("hfullAddress").value;
              this.center = {
                lat: latitude,
                lng: longitude,
              };
              if (
                typeof this.markers[0].position.lat != "undefined" &&
                typeof this.markers[0].position.lng != "undefined"
              ) {
                latitude = this.markers[0].position.lat;
                longitude = this.markers[0].position.lng;
              } else {
                this.markers[0].position.lat = latitude;
                this.markers[0].position.lng = longitude;
              }
              hfullAddress = hfullAddress.replace(/\s+/g, "+");
              axios
                .get(
                  "https://maps.googleapis.com/maps/api/geocode/json?address=" +
                    hfullAddress +
                    "&key=AIzaSyArGgueGCb2p4sqjU4pScADLskS9OxZ8jQ"
                )
                .then((response) => {
                  // Ideally you'd search for the index with type = sublocality in address_components
                  this.fillAddress(response.data.results);
                });
            }
          }
        })
        .catch((e) => {
          //alert('not ok')
        });
    },
  },
};
</script>
<style type="text/css">
.tg {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  border-color: #000;
  color: #000;
  font-family: "Poppins Regular";
}

.tg td {
  border-color: black;
  border-style: solid;
  border-width: 1px;
  font-size: 12px;
  overflow: hidden;
  padding: 10px 15px;
  word-break: normal;
}

.tg th {
  border-color: black;
  border-style: solid;
  border-width: 1px;
  font-size: 12px;
  overflow: hidden;
  padding: 10px 15px;
  word-break: normal;
}

.tg .tg-62l6 {
  border-color: inherit;
  font-size: 12px;
  font-weight: normal;
  text-align: center;
  vertical-align: top;
}

.tg .tg-0pky {
  border-color: inherit;
  text-align: left;
  vertical-align: top;
}

.nutritional-detail {
  color: #74c7fc !important;
  cursor: pointer !important;
}

input[type="radio"] {
  transform: scale(1.5);
}

.paymentType label {
  padding-left: 8px;
  width: 75%;
}

.paymentType img {
  width: 50px;
  height: 50px;
}

.paymentType p {
  padding-left: 0px;
  font-size: 12px;
  margin-bottom: 0px;
  font-weight: 600;
}

input[type="radio"]:checked {
  background-color: teal;
  background: teal;
  border-color: teal;
}

.inline {
  display: inline-block;
  border: 1px solid red;
  margin: 10px;
}
</style>
